import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import './style.css';

import { LeftMenuNavigator } from '../../components';

import ContatoContent from './contato';

const routes = [
  {
    title: 'Contato',
    link: '',
  },
];

function Contato() {
  let { path } = useRouteMatch();
  return (
    <div id="emprestimosMain">
      <LeftMenuNavigator title="Contato" routes={routes} />
      <div id="emprestimosContentContainer">
        <Switch>
          <Route exact path={path}>
            <ContatoContent />
          </Route>
        </Switch>
      </div>
    </div>
  )
}

export default Contato;
